import { type ComponentType, type PropsWithChildren } from "react"
import { ErrorBoundary, type FallbackProps } from "react-error-boundary"
import { Grid, Typography, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { TranslationKey } from "../../../modules/localization/translations"

const useStyles = makeStyles()((_theme) => ({
    contentWrapper: {
        width: "100%",
        height: "100%",
        padding: "1.5rem",
    },
    errorMessage: {
        textWrap: "wrap",
    },
}))

export function InlineFallbackContents(
    props:
        | FallbackProps
        | {
              icon?: JSX.Element
              errorMessageId?: TranslationKey
              externalClasses?: string
          },
) {
    const { classes, cx } = useStyles()

    const icon = "icon" in props ? props.icon : undefined
    const errorMessageId = "errorMessageId" in props ? props.errorMessageId : undefined
    const externalClasses = "externalClasses" in props ? props.externalClasses : undefined

    return (
        <Grid
            container
            direction="column"
            wrap="nowrap"
            justifyContent="space-between"
            className={cx(classes.contentWrapper, externalClasses)}
        >
            <Box>{icon}</Box>
            <LocalizedStrict id={errorMessageId ?? "inline-error-boundary-message"}>
                <Typography variant="subtitle1" color="#00000099" className={classes.errorMessage}>
                    Could not render contents
                </Typography>
            </LocalizedStrict>
        </Grid>
    )
}

type Props = Readonly<
    PropsWithChildren<{
        Fallback?: ComponentType<FallbackProps>
    }>
>

export function InlineErrorBoundary({ Fallback, children }: Props) {
    return <ErrorBoundary FallbackComponent={Fallback ? Fallback : InlineFallbackContents}>{children}</ErrorBoundary>
}
